import { render, staticRenderFns } from "./insideCaseInfo.vue?vue&type=template&id=c83f9790&"
import script from "./insideCaseInfo.vue?vue&type=script&lang=js&"
export * from "./insideCaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./insideCaseInfo.vue?vue&type=style&index=0&id=c83f9790&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports